/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setStoreEmailFilter } from "../index";

export const useStoreEmailFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setStoreEmailFilter({ key, value }));

  return { updateFilter };
};
